"use client";

import { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime";
import React, { useMemo } from "react";
import { Dialog, Modal } from "staysure-component-library";

import { useGetPaymentTitle } from "@/hooks/api/payment/magnolia-api";

import PaymentModalContent from "../payment-modal-content/payment-modal-content";

type PaymentModalProps = {
  isOpen: boolean;
  setIsOpen: (val: boolean) => void;
  type: "pclError" | "pclCancel" | "paymentError";
  router: AppRouterInstance;
};

function PaymentModal({
  isOpen,
  setIsOpen,
  type,
  router,
}: Readonly<PaymentModalProps>) {
  const paymentData = useGetPaymentTitle();

  const clearRoute = (status: boolean) => {
    setIsOpen(status);
    const { pathname } = window.location;
    const urlWithoutParams = window.location.origin + pathname;
    router.replace(urlWithoutParams);
  };

  const ModalTitle = useMemo(() => {
    switch (type) {
      case "paymentError":
        return paymentData?.errorPopModalTitle;
      case "pclError":
        return paymentData?.errorPopModalTitlePcl;
      case "pclCancel":
        return paymentData?.cancelPopModalTitle;
      default:
        return "Error";
    }
  }, [type, paymentData]);

  const ModalContent = useMemo(() => {
    switch (type) {
      case "paymentError":
        return paymentData?.errorPopModalContent;
      case "pclError":
        return paymentData?.errorPopModalContentPcl;
      case "pclCancel":
        return paymentData?.cancelPopModalContent;
      default:
        return "Error";
    }
  }, [type, paymentData]);

  const ModalButton = useMemo(() => {
    switch (type) {
      case "paymentError":
        return paymentData?.errorPopModalButton;
      case "pclError":
        return paymentData?.errorPopModalButtonPcl;
      case "pclCancel":
        return paymentData?.cancelPopModalButton;
      default:
        return "Error";
    }
  }, [type, paymentData]);

  return (
    <Modal
      isDismissable={false}
      onOpenChange={(e: boolean) => setIsOpen(e)}
      isOpen={isOpen}
      modalStyles={{
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
      className="bg-surface-neutral-option-1 w-[312px] md:w-[442px] lg:w-[588px] items-center justify-center  relative rounded-radius-xxl"
      uderlayClassName="z-[200] bg-interactive-overlay-default"
    >
      <Dialog>
        {paymentData && (
          <PaymentModalContent
            ModalTitle={ModalTitle ?? "Error"}
            ModalContent={ModalContent ?? "Error"}
            ModalButton={ModalButton ?? "Okay"}
            setIsOpen={clearRoute}
          />
        )}
      </Dialog>
    </Modal>
  );
}

export default PaymentModal;
